import script from "./ActivityType.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityType.vue?vue&type=script&setup=true&lang=js"

import "./ActivityType.vue?vue&type=style&index=0&id=2b286159&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b286159"]])

export default __exports__